<template>
  <v-dialog fullscreen v-model="getModalCadastroFuncionario" persistent>
    <v-card outlined :loading="$store.getters.getOverlay">
      <Alert />
      <v-app-bar flat class="px-3" color="white">
        <v-btn
          @click="
            ativaModalConfirmacao({
              mensagem:
                'Você perderá os dados que já preencheu caso não tenha salvo, deseja realmente voltar?',
              action: 'setModalCadastroFuncionario',
              action_value: false,
            })
          "
          icon
        >
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <h3>Funcionário</h3>
      </v-app-bar>
      <v-tabs app grow v-model="tabs" class="hidden-sm-and-down">
        <v-tab> Dados Cadastrais </v-tab>
        <v-tab @click="listarSalarios" v-if="getFuncionario.id"> Salários </v-tab>
        <v-tab @click="listarDependentes" v-if="getFuncionario.id"> Dependentes </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <v-form ref="form" class="px-3">
            <v-card-text>
              <v-layout row wrap class="">
                <v-flex xs12 md6>
                  <v-text-field
                    dense
                    outlined
                    v-model="getFuncionario.nome"
                    label="Nome"
                    class="ml-3 mr-3"
                    :rules="rules.nome"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    dense
                    outlined
                    v-model="getFuncionario.nome_abreviado"
                    label="Nome abreviado"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    dense
                    outlined
                    v-mask="['##.###.###/####-##', '###.###.###-##']"
                    v-model="getFuncionario.cpf_cnpj"
                    label="CPF/CNPJ"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    dense
                    outlined
                    v-model="getFuncionario.rg"
                    label="RG"
                    class="ml-3 mr-3"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    type="date"
                    dense
                    outlined
                    v-model="getFuncionario.data_admissao"
                    label="Data de Admissão"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-select
                    class="ml-3 mr-3"
                    outlined
                    dense
                    :items="getPerfis"
                    v-model="getFuncionario.perfil_id"
                    label="Perfil"
                    item-value="id"
                    item-text="perfil"
                    :rules="rules.perfil_id"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 md6>
                  <v-select
                    class="ml-3 mr-3"
                    outlined
                    dense
                    :items="getCargos"
                    v-model="getFuncionario.cargo_id"
                    label="Cargo"
                    item-value="id"
                    item-text="nome"
                    :rules="rules.cargo_id"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field
                    dense
                    outlined
                    v-mask="'#####-###'"
                    v-model="getFuncionario.cep"
                    label="CEP"
                    @blur="pesquisaCep"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    dense
                    outlined
                    v-model="getFuncionario.logradouro"
                    label="Logradouro"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    dense
                    outlined
                    v-model="getFuncionario.numero"
                    id="numero"
                    label="Número"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    dense
                    outlined
                    v-model="getFuncionario.complemento"
                    label="Complemento"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 md4>
                  <v-text-field
                    dense
                    outlined
                    v-model="getFuncionario.bairro"
                    label="Bairro"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    dense
                    outlined
                    v-model="getFuncionario.cidade"
                    label="Cidade"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    dense
                    outlined
                    v-model="getFuncionario.uf"
                    label="UF"
                    class="ml-3 mr-3"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    dense
                    outlined
                    v-model="getFuncionario.email"
                    label="E-mail"
                    class="ml-3 mr-3"
                    :rules="rules.email"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    dense
                    outlined
                    v-mask="'(##) ####-####'"
                    v-model="getFuncionario.contato"
                    label="Contato"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <!-- <v-flex xs12 md6>
                                <v-select class="ml-3 mr-3" outlined dense :items="situacaoFuncionario"
                                    v-model="getFuncionario.cargo_funcao" label="Cargo/Função"></v-select>
                            </v-flex> -->
                <v-flex xs12 md6>
                  <v-select
                    class="ml-3 mr-3"
                    outlined
                    dense
                    :items="situacaoFuncionario"
                    v-model="getFuncionario.situacao"
                    label="Situação"
                    :rules="rules.situacao"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md6>
                  <v-select
                    class="ml-3 mr-3"
                    outlined
                    dense
                    :items="getEmpresas"
                    v-model="getFuncionario.empresa_id"
                    label="Unidade"
                    item-text="razao_social"
                    item-value="id"
                    :rules="rules.empresa_id"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    class="ml-3 mr-3"
                    outlined
                    dense
                    label="Login"
                    v-model="getFuncionario.login"
                    :rules="rules.login"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    dense
                    type="password"
                    label="Senha"
                    class="ml-3 mr-3"
                    outlined
                    v-model="getFuncionario.password"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    dense
                    type="password"
                    label="Confirmação de Senha"
                    class="ml-3 mr-3"
                    outlined
                    v-model="getFuncionario.password_confirmation"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-btn
                v-if="
                  getFuncionario.id &&
                  $helper.verificaPermissao('cadastrar-funcionario')
                "
                color="primary"
                @click="cadastrarFuncionario"
                outlined
                >Novo</v-btn
              >
              <v-btn
                v-if="
                  getFuncionario.id &&
                  $helper.verificaPermissao('excluir-funcionario')
                "
                color="error"
                @click.stop="setModalExcluirFuncionario(true)"
                outlined
                >Excluir</v-btn
              >
              <v-btn
                color="default"
                @click="
                  ativaModalConfirmacao({
                    mensagem:
                      'Você perderá os dados que já preencheu caso não tenha salvo, deseja realmente voltar?',
                    action: 'setModalCadastroFuncionario',
                    action_value: false,
                  })
                "
                outlined
              >
                Voltar</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                @click="salvar"
                outlined
                :loading="$store.getters.getOverlay"
                v-if="
                  $helper.verificaPermissao('cadastrar-funcionario') ||
                  $helper.verificaPermissao('atualizar-funcionario')
                "
                >Salvar</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-tab-item>

        <v-tab-item>
          <div style="flex-wrap: wrap" class="expande-horizontal coluna pa-3">
            <v-flex xs12>
              <div class="expande-horizontal">
                <v-flex class="px-1" xs12 md4>
                  <v-select
                    v-model="getSalario.mes"
                    label="Mês"
                    :items="[
                      'Janeiro',
                      'Fevereiro',
                      'Março',
                      'Abril',
                      'Maio',
                      'Junho',
                      'Julho',
                      'Agosto',
                      'Setembro',
                      'Outubro',
                      'Novembro',
                      'Dezembro',
                      'Férias'
                    ]"
                    outlined
                    dense
                  ></v-select>
                </v-flex>
                <v-flex class="px-1" xs12 md4>
                  <v-text-field
                    v-model="getSalario.ano"
                    label="Ano"
                    v-mask="['####']"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex class="px-1" xs12 md3>
                  <v-text-field
                    v-model="getSalario.valor"
                    label="Valor"
                    prefix="R$"
                    v-mask="[
                      '#,##',
                      '##,##',
                      '###,###',
                      '#.###,##',
                      '##.###,##',
                      '###.###,##',
                    ]"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>

                <v-flex class="px-1" xs12 md1>
                  <v-btn @click="cadastrarSalario" icon outlined>
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-flex>
              </div>
            </v-flex>

            <v-flex xs12>
              <v-data-table
                :headers="headersSalarios"
                :items="getSalarios"
                :search="searchSalarios"
                item-key="ano"
              ></v-data-table>
            </v-flex>
          </div>
        </v-tab-item>

        <v-tab-item>
          <div style="flex-wrap: wrap" class="expande-horizontal coluna pa-3">
            <v-flex xs12>
              <div class="expande-horizontal">
                <v-flex class="px-1" xs12 md4>
                  <v-text-field
                    v-model="getDependente.nome"
                    label="Nome"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex class="px-1" xs12 md3>
                  <v-text-field
                    v-model="getDependente.data_nascimento"
                    label="Nascimento"
                    type="date"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex class="px-1" xs12 md3>
                  <v-text-field
                    v-model="getDependente.grau_parentesco"
                    label="Grau de Parentesco"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>

                <v-flex class="px-1" xs12 md1>
                  <v-btn @click="cadastrarDependente" icon outlined>
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-flex>
              </div>
            </v-flex>

            <v-flex xs12>
              <v-data-table
                :headers="headersDependentes"
                :items="getDependentes"
                :search="searchDependentes"
              >
                <template v-slot:[`item.data_nascimento`]="{ item }">
                  <span>
                    {{
                      moment(item.data_nascimento).format("DD/MM/YYYY")
                    }}</span
                  >
                </template>
              </v-data-table>
            </v-flex>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <ModalExcluirFuncionario />
    <ModalConfirmacao />
  </v-dialog>
</template>

<script>
import ModalExcluirFuncionario from "@/pages/funcionario/ModalExcluir";
import { mapGetters, mapActions } from "vuex";
import Moment from "moment";
export default {
  components: {
    ModalExcluirFuncionario,
  },
  data() {
    return {
      tabs: 0,
      moment: Moment,
      modalConfirmacao: false,
      situacaoFuncionario: ["ATIVADO", "DESATIVADO"],
      rules: {
        nome: [(v) => !!v || "Campo obrigatório."],
        perfil_id: [(v) => !!v || "Campo obrigatório."],
        cargo_id: [(v) => !!v || "Campo obrigatório."],
        situacao: [(v) => !!v || "Campo obrigatório."],
        email: [(v) => !!v || "Campo obrigatório."],
        empresa_id: [(v) => !!v || "Campo obrigatório."],
        empresa_id: [(v) => !!v || "Campo obrigatório."],
        login: [(v) => !!v || "Campo obrigatório."],
      },
      searchSalarios: "",
      searchDependentes: "",
      headersSalarios: [
        {
          text: "Mês",
          value: "mes",
        },
        {
          text: "Ano",
          value: "ano",
        },
        {
          text: "Valor",
          value: "valor",
        },
      ],
      headersDependentes: [
        {
          text: "Nome",
          value: "nome",
        },
        {
          text: "Nascimento",
          value: "data_nascimento",
        },
        {
          text: "Grau de Parentesco",
          value: "grau_parentesco",
        },
      ],
    };
  },
  watch: {
    getModalCadastroFuncionario() {
      if (this.getModalCadastroFuncionario) {
        document.addEventListener("keydown", this.keyUp);
      } else {
        document.removeEventListener("keydown", this.keyUp);
      }
    },
  },
  computed: {
    ...mapGetters([
      "getFuncionario",
      "getModalCadastroFuncionario",
      "getPerfis",
      "getEmpresas",
      "getCargos",
      "getDependente",
      "getSalario",
      "getDependentes",
      "getSalarios",
    ]),
  },
  methods: {
    ...mapActions([
      "setDependente",
      "setSalario",
      "setFuncionario",
      "ativaModalConfirmacao",
      "setModalCadastroFuncionario",
      "setModalExcluirFuncionario",
      "cadastrarFuncionario",
      "salvarFuncionario",
      "atualizarFuncionario",
      "listarPerfil",
      "listarEmpresa",
      "listarCargo",
      "cadastrarSalario",
      "cadastrarDependente",
      "listarSalarios",
      "listarDependentes",
    ]),
    salvar() {
      if (this.$refs.form.validate()) {
        if (this.getFuncionario.id) {
          this.atualizarFuncionario(this.getFuncionario);
        } else {
          this.salvarFuncionario(this.getFuncionario);
        }
      }
    },
    pesquisaCep() {
      this.$http
        .get(`https://viacep.com.br/ws/${this.getFuncionario.cep}/json/`)
        .then((res) => {
          this.getFuncionario.logradouro = res.data.logradouro;
          this.getFuncionario.bairro = res.data.bairro;
          this.getFuncionario.cidade = res.data.localidade;
          this.getFuncionario.uf = res.data.uf;
          document.getElementById("numero").focus();
        })
        .catch((err) => alert("CEP Inválido."));
    },
    keyUp(e) {
      if (!e) e = window.event;
      let keyCode = e.keyCode || e.which;

      if (keyCode == 27) {
        this.ativaModalConfirmacao({
          aberto: true,
          icone: "warning",
          cor: "yellow darken-3",
          mensagem:
            "Você perderá os dados que já preencheu caso não tenha salvo, deseja realmente voltar?",
          action: "setModalCadastroFuncionario",
          action_value: false,
        });
      }
    },
  },
  created() {
    this.listarPerfil();
    this.listarEmpresa();
    this.listarCargo();
  },
};
</script>
